// Alteration Station - Garment alterations and repairs department
import React from 'react';
import { Scissors } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const AlterationStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="alteration"
      stationName="Alterations"
      stationIcon={<Scissors className="w-6 h-6" />}
      stationColor="#8B5CF6"
      showAdvanceButton={true}
      showCustomerContact={false}
      showDeliveryInfo={false}
    />
  );
};

export default AlterationStation;
